// Share-image (og:image / twitter:image) selection and URL handling.
// Mirrors server/utils/shareImage.js - keep the two in sync. No env import, so
// it stays testable under plain node.

function clean(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

// The image a shared product link should show: the admin-selected SEO image,
// then the main photo, then the rest of the gallery in display order. Returns
// '' when the product has no usable image, so callers can fall back to the
// site default.
export function pickProductShareImage(product) {
  if (!product) return '';
  const images = Array.isArray(product.images) ? product.images : [];
  const main = images.find((i) => Number(i?.is_main) === 1 || i?.is_main === true);
  const candidates = [
    product.seo?.og_image_url,
    main?.image_url,
    ...images.map((i) => i?.image_url),
    product.main_image_url,
    product.image,
  ];
  for (const c of candidates) {
    if (clean(c)) return clean(c);
  }
  return '';
}

// Alt text for the image pickProductShareImage() chose.
export function productShareImageAlt(product) {
  if (!product) return '';
  const url = pickProductShareImage(product);
  const img = (product.images || []).find((i) => clean(i?.image_url) === url);
  return clean(img?.alt_text) || clean(product.name);
}

// Absolute URL for an asset. Unlike page canonicals (canonicalUrl.js), an asset
// URL keeps its own host: images live on S3 / CloudFront, and re-pointing them
// at the site's canonical host sends crawlers to the SPA instead of the file.
// Only relative paths are resolved against `origin`.
export function absoluteAssetUrl(value, origin) {
  const v = clean(value);
  if (!v) return '';
  if (/^https?:\/\//i.test(v)) return v;
  if (v.startsWith('//')) return `https:${v}`;
  const base = clean(origin).replace(/\/+$/, '');
  const path = v.startsWith('/') ? v : `/${v}`;
  return base ? `${base}${path}` : path;
}
